import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sourceId", "productLine", "className", "use", "ctaKey", "style", "nonMerchandiseIdProduct"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { SIGNUP } from 'pricing-pages-lib/constants/CtaTypes';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getGAClassName, getHubsSignupCTA, getHubsSignupUrl, getPublicSiteDomain } from 'pricing-pages-lib/utils/publicPageUrls';
import { Metrics } from 'pricing-pages-ui/utils/metrics';
import { useSelector } from 'react-redux';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { Flow } from 'signup-constants/Flow';
import partial from 'transmute/partial';
import { omit } from 'underscore';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { generateSignupUrlWithQueryParams } from '../../utils/urls/generateSignupUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const ELIGIBLE_PRODUCT_LINES_TO_SIGNUP = {
  [MARKETING]: Flow.Marketing,
  [SALES]: Flow.Sales,
  [SERVICE]: Flow.Service,
  [CMS]: Flow.CmsFree,
  [COMMERCE]: Flow.Commerce,
  crm: Flow.Crm
};
const trackClick = (sourceId, signupType) => {
  getUsageTracker().track('signupClick', {
    sourceId,
    signupType
  });
  Metrics.counter('signup-clicked').increment();
};
const SignupButton = _ref => {
  let {
      sourceId,
      productLine,
      className,
      use = 'primary',
      ctaKey = 'pricingPage.signupCtas.getStartedFree',
      style,
      nonMerchandiseIdProduct
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hubsSignupUrl = getHubsSignupUrl({});
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const signupType = Object.keys(ELIGIBLE_PRODUCT_LINES_TO_SIGNUP).includes(productLine) ? ELIGIBLE_PRODUCT_LINES_TO_SIGNUP[productLine] : Flow.Crm;
  const hubsSignupCta = getHubsSignupCTA({
    pathname: window.location.pathname,
    ctaType: SIGNUP,
    sourceId,
    productLine,
    nonMerchandiseIdProduct
  });
  const gaClassName = getGAClassName(hubsSignupCta);
  const domain = getPublicSiteDomain();
  const domainWithoutHttps = domain.replace(/^https:\/\//, '');
  const HREF = generateSignupUrlWithQueryParams({
    signupType,
    queryParams: {
      hubsSignupCta,
      hubsSignupUrl,
      domainWithoutHttps,
      pathname: window.location.pathname,
      isUngatedForSeats
    }
  });
  const isInApp = useSelector(isAppAuthSelector);
  const propsToPass = omit(rest, ['dispatch']);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: use,
    href: isInApp ? null : HREF,
    className: `${gaClassName} ${className}`,
    disabled: isInApp,
    onClick: partial(trackClick, sourceId, signupType),
    style: style,
    "data-selenium-id": `sign-up-button-${productLine}`
  }, propsToPass, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ctaKey,
      className: gaClassName
    })
  }));
};
export default SignupButton;